
import {
  formatByCountry,
  formatInputByCountry,
  parseByCountry,
  parsingErrorResponse,
  resolveCountry
} from "@/app/infrastructures/misc/Utils";
import { DashboardController } from "@/app/ui/controllers/DashboardController";
import {
  CourierDetail,
  CourierDetailApiRequest,
  CourierNotesPhoto,
  CourierSummary,
  TaskSetllementCourier
} from "@/domain/entities/CodReconcile";
import { Options, Vue, prop } from "vue-class-component";
import SectionUploadPhotoCodReconcile from "../section-upload-photo-cod-reconcile.vue";
import Notes from "../notes.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { CodReconcileController } from "@/app/ui/controllers/CodReconcileController";
import {
  GetCourierNotes,
  SubmitCourierNotes,
  SubmitCourierNotesPhotos,
  TaskSettlementCourierParams
} from "@/data/payload/api/CodReconcileApiRequest";
import {
  ErrorMessageEntities,
  ModalMessageEntities
} from "@/domain/entities/MainApp";
import { CourierDailyDepositRequest } from "@/data/payload/api/DashboardRequests";
import SummaryCollapsible from "../summary-collapsible.vue";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { CourierPartnerCodDashboard } from "@/domain/entities/Dashboard";
import CardDeposit from "@/app/ui/views/cod-delivery-v2/components/daily-deposit/card-deposit.vue";
import ImagePreviewReconcile from "../image-preview-reconcile.vue";
import formatPriceRP from '@/app/infrastructures/misc/common-library/v2/FormatPriceRP';

class Prop {
  courier = prop<CourierPartnerCodDashboard>({
    default: new CourierPartnerCodDashboard(),
    type: CourierPartnerCodDashboard
  });
  filterDate = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  components: {
    SectionUploadPhotoCodReconcile,
    Notes,
    SummaryCollapsible,
    CardDeposit,
    ImagePreviewReconcile
  }
})
export default class MoneyTab extends Vue.with(Prop) {
  form = {
    deposit: ""
  };
  courierSummary = new CourierSummary();
  courierNotes = "";
  courierNotePhotos: CourierNotesPhoto[] = [];
  courierNotesLoading = false;
  previewCourierNotesPhoto = false;
  previewCourierNotesPhotoIndex = 0;
  detailDataCourier: any = {};
  detailDashbordCourier: any = {};
  type = "courier";
  refs = null as any;

  mounted() {
    this.getAllData();
    this.refs = this.$refs;
  }

  getAllData() {
    if (!this.courier?.courierId) return;

    this.getCourierNotes();
    this.getDetailCourierSuccess();
    this.getCourierSummaryDetail();
    this.getTaskSettlementList();
  }

  async getCourierSummaryDetail(date?: Date) {
    try {
      MainAppController.showLoading();
      const res: CourierSummary = await CodReconcileController.getCourierSummaryDetailV2(
        {
          params: new CourierDetailApiRequest({
            type: "DRIVER",
            filterDate: this.$moment(date || this.filterDate).format(
              "YYYY-MM-DD"
            ),
            driverPhone: this.courier.courierPhone.replace(/^\+/, ""),
            hubId: getHubData()?.hubId || 0
          }),
          version: "v3"
        }
      );

      this.courierSummary = res;
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          "Gagal Mendapatkan Summary!",
          this.getCourierSummaryDetail
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  detailCourierSuccess: CourierDetail[] = [];
  async getDetailCourierSuccess() {
    try {
      MainAppController.showLoading();
      const res: CourierDetail[] = await CodReconcileController.getCourierDetailV2(
        {
          params: new CourierDetailApiRequest({
            type: this.type,
            filterDate: this.$moment(this.filterDate).format("YYYY-MM-DD"),
            driverPhone: this.courier.courierPhone,
            status: "success"
          }),
          version: "v3"
        }
      );
      this.detailCourierSuccess = res.filter(
        (e: CourierDetail) =>
          e.sttStatus === "POD" &&
          e.sttCollectionStatus.toLowerCase() === "belum setor"
      );
    } catch (error) {
      const message = (error as any)?.response?.data?.message;
      MainAppController.showErrorMessage(
        typeof message === "string"
          ? new ErrorMessageEntities({
              title: "Gagal Mengambil Detail Kurir",
              message
            })
          : parsingErrorResponse(error)
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  settlementListData: TaskSetllementCourier[] = [];
  async getTaskSettlementList() {
    try {
      MainAppController.showLoading();
      const res: TaskSetllementCourier[] = await CodReconcileController.getTaskSettlementCourier(
        new TaskSettlementCourierParams({
          reconcileStatus: "HIDE_ALL",
          reconcileFor: "COD_AMOUNT",
          id: Number(this.courier.courierId),
          date: this.$moment(this.filterDate).format("YYYY-MM-DD") as string
        })
      );
      this.settlementListData = res || [];
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          "Gagal mengambil data setllement",
          this.getTaskSettlementList
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async getCourierNotes() {
    const resp = await CodReconcileController.getCourierNotes(
      new GetCourierNotes({
        reconcileFor: "COD_AMOUNT",
        courierId: Number(this.courier.courierId),
        date: this.$moment(this.filterDate).format("YYYY-MM-DD")
      })
    );

    this.courierNotePhotos = resp.photos;
    this.courierNotes = resp.note;
    if (!this.courierNotePhotos.length) {
      this.courierNotePhotosUrl = ["", "", "", ""];
    } else {
      const remainingSlot = 4 - this.courierNotePhotos.length;
      for (let i = 0; i < remainingSlot; i++) {
        this.courierNotePhotosUrl.push("");
      }
    }
  }

  get prefixCurrency() {
    return resolveCountry() === "MY" ? "RM" : "Rp";
  }

  formatMoney(value: string) {
    return formatInputByCountry(value, { type: "money" });
  }
  isErrorDeposit = false;
  validationInput(value: string, type: string) {
    const inputValue = value.toString();
    const inputDeposit = parseByCountry(inputValue);
    if (type === "deposit") {
      this.isErrorDeposit =
        !value ||
        (value !== "0" &&
          inputDeposit !== this.courierSummary.codAmountDeposit?.pending);
    }
    return false;
  }

  get courierNotePhotosUrl() {
    return this.courierNotePhotos.map((photo) => photo.url);
  }
  set courierNotePhotosUrl(payload: string[]) {
    this.courierNotePhotos = payload.map((url) => {
      const existingData = this.courierNotePhotos.find(
        (photo) => photo.url === url
      );

      if (existingData) return existingData;
      return new CourierNotesPhoto({
        url,
        uploadedAt: new Date().toISOString(),
        uploadedBy: AccountController.accountData.account_id,
        uploadedByType: AccountController.accountData.account_type_detail.type
      });
    });
  }

  async onSubmitCourierNotesPhoto(payload: { url: string; index: number }) {
    try {
      this.courierNotePhotosUrl[payload.index] = payload.url;
      MainAppController.showLoading();
      const requestPayload = new SubmitCourierNotesPhotos({
        reconcileFor: "COD_AMOUNT",
        courierId: Number(this.courier.courierId),
        date: this.$moment(this.filterDate).format("YYYY-MM-DD"),
        photos: this.courierNotePhotos.filter((photo) => photo.url)
      });
      await CodReconcileController.uploadCourierNotesPhotos(requestPayload);
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          "Gagal mengupload foto catatan kurir",
          this.onSubmitCourierNotesPhoto
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onSubmitCourierNotes() {
    try {
      this.courierNotesLoading = true;
      const payload = new SubmitCourierNotes({
        reconcileFor: "COD_AMOUNT",
        courierId: Number(this.courier.courierId),
        date: this.$moment(this.filterDate).format("YYYY-MM-DD"),
        note: this.courierNotes
      });
      await CodReconcileController.submitCourierNotes(payload);
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          "Gagal menyimpan catatan kurir",
          this.onSubmitCourierNotes
        )
      );
    } finally {
      this.courierNotesLoading = false;
    }
  }

  get isDisabled() {
    return (
      (this.courierSummary.codAmountDeposit?.pending && !this.form.deposit) ||
      (!this.courierSummary.codAmountDeposit?.pending &&
        !this.dataSelected.length) ||
      this.isErrorDeposit
    );
  }

  dataSelected: string[] = [];
  selectData(data: CourierDetail[]) {
    this.dataSelected = data.map((e: CourierDetail) => e.sttNo);
  }

  get depositValue() {
    return !this.form.deposit ||
      this.form.deposit === "0" ||
      this.isErrorDeposit
      ? 0
      : this.courierSummary.codAmountDeposit?.pending;
  }

  formatPriceRp(value: number) {
    return formatByCountry(value, { type: "money", prefix: this.prefixCurrency });
  }

  get courierSummaryAmount() {
    return this.formatPriceRp(
      this.courierSummary.codAmountDeposit?.pending || 0
    );
  }

  get dataSummarySuccess() {
    return this.detailCourierSuccess.map((e: CourierDetail) => ({
      sttNo: e.sttNo,
      serviceType: e.sttCodType || "-",
      amount: this.formatPriceRp(e.sttCodAmount || 0)
    }));
  }

  async postCourierDailyDeposit() {
    try {
      MainAppController.showLoading();
      const response = await DashboardController.postCourierDailyDepositV3({
        type: this.type,
        payload: new CourierDailyDepositRequest({
          driverPhone: this.courier.courierPhone.replaceAll("+", ""),
          picPhone: this.courier.courierPhone.replaceAll("+", ""),
          filterDate: this.$moment(this.filterDate).format("YYYY-MM-DD"),
          totalAmount: this.depositValue,
          stt: this.dataSelected
        })
      });

      if (response.success) {
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            title: this.$t("codReconcile.dailyDeposit.successTitle"),
            message: this.$t("codReconcile.dailyDeposit.successMessage", {
              amount: this.formatPriceRp(this.depositValue),
              sttCount: this.dataSelected.length
            }),
            textSuccess: "OK",
            onSubmit: () => {
              MainAppController.closeMessageModal();
            }
          })
        );
      }
    } catch (error) {
      const errorMessage = (error as any)?.response?.data?.message?.id;
      MainAppController.showErrorMessage(
        errorMessage
          ? new ErrorMessageEntities({
              type: "client-error",
              title: this.$t("codReconcile.dailyDeposit.errorTitle"),
              message: errorMessage,
              buttonSuccessText: "OK"
            })
          : parsingErrorResponse(
              error,
              this.$t("codReconcile.dailyDeposit.errorMessage"),
              this.postCourierDailyDeposit
            )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
}
